import { AnimatePresence, motion } from 'framer-motion';
import { useReducedMotion } from '../../hooks/useReducedMotion';

export const RouteActivationOverlay = ({ routeKey }: { routeKey: string }) => {
  const reducedMotion = useReducedMotion();

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={routeKey}
        initial={{ opacity: 0.42 }}
        animate={{ opacity: 0 }}
        exit={{ opacity: 0 }}
        transition={{ duration: reducedMotion ? 0.12 : 0.45, ease: 'easeOut' }}
        className="pointer-events-none fixed inset-0 z-40 bg-[radial-gradient(circle_at_50%_50%,rgba(183,255,106,0.12),rgba(2,6,9,0.05)_58%,transparent)]"
      >
        <motion.div
          className="absolute inset-y-0 left-[-26%] w-[24%] bg-[linear-gradient(90deg,transparent,rgba(183,255,106,0.25),transparent)]"
          animate={reducedMotion ? undefined : { x: ['0%', '520%'], opacity: [0, 0.8, 0] }}
          transition={{ duration: 0.7, ease: 'linear' }}
        />
      </motion.div>
    </AnimatePresence>
  );
};
